import React, { useState } from "react";
import "./Projects.css";
import bgTabOne1 from "../../asset/image.png"; // Image for Tab One
import bgTabOne2 from '../../asset/image3.png';
import bgTabOne3 from '../../asset/image2.png';
import bgTabTwo from '../../asset/image2.png';
import bgTabTwo1 from '../../asset/download1.jpg';
import bgTabTwo2 from '../../asset/download.jpg';
import bgTabThree from "../../asset/download2.jpg"; // Image for Tab Three
import bgTabThree1 from "../../asset/download1.jpg"; // Image for Tab Three
import bgTabThree2 from "../../asset/image2.png"; // Image for Tab Three


const Projects = () => {

  const [activeTab, setActiveTab] = useState("tabOne");

  const tabs = {
    tabOne: [
      { id: 1, title: "Travel The World", bg: bgTabOne1 },
      { id: 2, title: "Explore Nature", bg: bgTabOne2 },
      { id: 3, title: "Adventure Awaits", bg: bgTabOne3 },
    ],
    tabTwo: [
      { id: 1, title: "Let's Do It Together", bg: bgTabTwo },
      { id: 2, title: "Teamwork Makes Dreams Work", bg: bgTabTwo1 },
      { id: 3, title: "Collaboration Rocks", bg: bgTabTwo2 },
    ],
    tabThree: [
      { id: 1, title: "Boost Your Startup", bg: bgTabThree1 },
      { id: 2, title: "Innovate and Elevate", bg: bgTabThree2 },
      { id: 3, title: "Launch Into Success", bg: bgTabThree },
    ],
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <section className="projects">
    <div className="projects-container">
        <h1 className="projectTitle">Projects</h1>

      {/* Tabs */}
      <div className="tabs">
        <button
          className={`tab-button ${activeTab === "tabOne" ? "active" : ""}`}
          onClick={() => handleTabClick("tabOne")}
        >
          Tab One
        </button>
        <button
          className={`tab-button ${activeTab === "tabTwo" ? "active" : ""}`}
          onClick={() => handleTabClick("tabTwo")}
        >
          Tab Two
        </button>
        <button
          className={`tab-button ${activeTab === "tabThree" ? "active" : ""}`}
          onClick={() => handleTabClick("tabThree")}
        >
          Tab Three
        </button>
      </div>

      {/* Project Cards */}
      <div className="projects-grid">
        {tabs[activeTab].map((project) => (
          <div
            key={project.id}
            className="project-card"
            style={{ backgroundImage: `url(${project.bg})` }}
          >
            <div className="project-title">{project.title}</div>
          </div>
        ))}
      </div>
    </div>
    </section>
  );
};

export default Projects;
